import React from 'react';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import Projects from './components/Projects';
import ScrollTop from './components/ScrollTop';
import Skills from './components/Skills';

function App() {
  return(
    <>
      <Header />
      <main className="h-screen section-container md:blur-none">
        <section id="home" className="h-screen bg-zinc-900 p-5">
          <Hero />
        </section>
        <section id="about" className="min-h-screen bg-zinc-850 flex items-center">
          <About />
        </section>
        <section id="skills" className="min-h-screen bg-zinc-900">
          <Skills />
        </section>
        <section id="projects" className="min-h-screen bg-zinc-850">
          <Projects />
        </section>
        <section id="contact" className="min-h-screen bg-zinc-900 flex items-center justify-center md:justify-start">
          <Contact />
        </section>
        <Footer />
      </main>
      <ScrollTop />
    </>
  );
}

export default App;
